import { subscribeToLists, type LeadList } from '@/services/firebase/firestore';
import type { Unsubscribe } from 'firebase/firestore';
import { useEffect, useRef, useState } from 'react';

export interface UseListsResult {
  lists: LeadList[];
  loading: boolean;
  error: string | null;
}

export const useLists = (): UseListsResult => {
  const [lists, setLists] = useState<LeadList[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const unsubscribeRef = useRef<Unsubscribe | null>(null);

  useEffect(() => {
    unsubscribeRef.current = subscribeToLists(
      (data) => {
        setLists(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Lists subscription error:', err);
        setError(err.message || 'Failed to load lists');
        setLoading(false);
      }
    );

    return () => {
      unsubscribeRef.current?.();
      unsubscribeRef.current = null;
    };
  }, []);

  return { lists, loading, error };
};

export default useLists;
